/**
 * Client-side identity for workflow designer list items (triggers, phases,
 * actions). Server ids only exist after the first save, so unsaved items need
 * an identity of their own from the moment they are created — React keys and
 * per-item component state (expanded panels, form editors) otherwise bleed
 * between items when the list changes.
 *
 * The key is UI-only: `MapWorkflowDefinitionResponseToWorkflowDefinitionRequest`
 * strips it before anything is sent to the API.
 */
export interface IClientKeyed {
  clientKey?: string;
}

let counter = 0;

export const nextClientKey = (): string => `client-${++counter}`;

/** Stable React key for a designer list item. */
export const itemKey = (
  item: {id?: number} & IClientKeyed,
  index: number
): string | number => item.id ?? item.clientKey ?? index;
